import { makeObservable, action, observable } from 'mobx';

class SearchStore {
    searchTerm = '';
    rawSearchTerm = ''; // Add this line to declare the observable
    searchResults = [];
    searchFilterStates = new Map();

    constructor() {
        console.warn('SearchStore constructor');

        makeObservable(this, {
            searchTerm: observable,
            rawSearchTerm: observable, // Make rawSearchTerm observable
            searchResults: observable,
            setSearchTerm: action.bound,
            setRawSearchTerm: action.bound,
            setSearchResults: action.bound,
            setSearchFilterState: action.bound,
            clearSearchFilterState: action.bound,
        });
    }

    setRawSearchTerm(term) {
        this.rawSearchTerm = term;
    }

    setSearchTerm(term) {
        this.searchTerm = term.trim(); // Trim the term before setting it
    }

    setSearchResults(results) {
        this.searchResults = results;
    }

    cloneFilterState(filterState) {
        if (!filterState || typeof filterState !== 'object') return null;
        return Object.fromEntries(
            Object.entries(filterState).map(([key, value]) => [key, Array.isArray(value) ? [...value] : []]),
        );
    }

    getSearchFilterState(locationKey) {
        if (!locationKey) return null;
        return this.cloneFilterState(this.searchFilterStates.get(locationKey));
    }

    setSearchFilterState(locationKey, filterState) {
        if (!locationKey) return;
        const clonedFilterState = this.cloneFilterState(filterState);
        if (!clonedFilterState) return;
        this.searchFilterStates.set(locationKey, clonedFilterState);
    }

    clearSearchFilterState(locationKey) {
        if (!locationKey) return;
        this.searchFilterStates.delete(locationKey);
    }
}

const createSearchStore = async (userId) => {
    const store = new SearchStore();
    return store;
};

export default createSearchStore;
